const assetStickers = {
  "Male": {
    "Aura": [
      "Awaken.PNG",
      "Intention.PNG",
      "Love.PNG",
      "Mind.PNG",
      "Movement.PNG",
      "Nourish.PNG",
      "Peace.PNG",
      "Wisdom.PNG"
    ],
    "Bling": [
      "Alien+Bling+Single.PNG",
      "Alien+Bling.PNG",
      "Bolt+Bling+Single.PNG",
      "Bolt+Earrings.PNG",
      "Bolt.PNG",
      "Diamond.PNG",
      "Gold.PNG",
      "Guitar+Bling+Single.PNG",
      "Guitar+Bling.PNG",
      "Mary+Jane+Bling+Single.PNG",
      "Mary+Jane+Bling.PNG",
      "Mary+Jane+Earrings.PNG",
      "Moon+Bling+Single.PNG",
      "Moon+Bling.PNG",
      "Moon+Earrings.PNG",
      "Peace+Beads.PNG",
      "Rainbow+Bling+Single.png",
      "Rainbow+Bling.PNG",
      "Rainbow+Earrings.PNG",
      "Scarf+Hippie+Blue.PNG",
      "Scarf+Hippie+Noir.PNG",
      "Scarf+Hippie+Oat.PNG",
      "Scarf+Peace+Emerald.PNG",
      "Scarf+Peace+Gold.PNG",
      "Shroom+Earrings.PNG",
      "Shroom+Single.PNG",
      "Smilie+Bling+Single.PNG",
      "Smilie+Bling.PNG",
      "Smilies+Earrings.PNG"
    ],
    "Hats": [
      "Beanie+Aqua.PNG",
      "Beanie+Gold.PNG",
      "Beanie+Oat.PNG",
      "Bucket+Blue.PNG",
      "Bucket+Frog+Blue.PNG",
      "Bucket+Frog+Emerald.PNG",
      "Bucket+Frog+Noir.PNG",
      "Bucket+Gold.PNG",
      "Bucket+Hippie+Noir.PNG",
      "Bucket+Hippie+Oat.PNG",
      "Bucket+Oat.PNG",
      "Bucket+Orange.PNG",
      "Bucket+Peace+Emerald.PNG",
      "Bucket+Peace+Noir.PNG",
      "Bucket+Peace+Oat.PNG",
      "Bucket+Peace.PNG",
      "Bucket+Smilie+Blue.PNG",
      "Bucket+Smilie+Gold.PNG",
      "Bucket+Smilie+Noir.PNG",
      "Captain.PNG",
      "Cowboy+Brown.PNG",
      "Flower+Headband.PNG",
      "Frida+Flowers.PNG",
      "Gold+Crown.PNG",
      "Halo.PNG",
      "Headphones+Noir.PNG",
      "Horns.PNG",
      "Panama.PNG",
      "Third+Eye+Open+Cosmic.PNG",
      "Third+Eye+Open.PNG",
      "Third+Eye+Portal+Cosmic.PNG",
      "Third+Eye+Portal.PNG",
      "Third+Eye+Sleeping.PNG",
      "Trucker+Blue.PNG",
      "Trucker+Gold.PNG",
      "Trucker+Noir.PNG",
      "Trucker+Orange.PNG",
      "Trucker+Pink.PNG",
      "Vibes+Beanie+Blue.PNG",
      "Vibes+Beanie+Emerald.PNG",
      "Vibes+Beanie+Noir.PNG",
      "Visor.PNG"
    ],
    "Hair": [
      "Bushy+Blue.PNG",
      "Bushy+Cacao.PNG",
      "Bushy+Gold.PNG",
      "Bushy+Noir.PNG",
      "Bushy+Oat.PNG",
      "Buzz+Blue.PNG",
      "Buzz+Cacao.PNG",
      "Buzz+Gold.PNG",
      "Buzz+Noir.PNG",
      "Buzz+Sienna.PNG",
      "Crew+Blue.PNG",
      "Crew+Cacao.PNG",
      "Crew+Emerald.PNG",
      "Crew+Noir.PNG",
      "Crew+Oat.PNG",
      "Crew+Sienna.PNG",
      "Fringe+Aqua.PNG",
      "Fringe+Blue.PNG",
      "Fringe+Cacao.PNG",
      "Fringe+Gold.PNG",
      "Fringe+Noir.PNG",
      "Fringe+Oat.PNG",
      "Fringe+Sienna.PNG",
      "Fro+Aqua.PNG",
      "Fro+Cacao.PNG",
      "Fro+Gold.PNG",
      "Fro+Noir.PNG",
      "Fro+Oat.PNG",
      "Fro+Sienna.PNG",
      "Hippie+Aqua+Headband.PNG",
      "Hippie+Aqua.PNG",
      "Hippie+Cacao+Headband.PNG",
      "Hippie+Cacao.PNG",
      "Hippie+Gold+Headband.PNG",
      "Hippie+Gold.PNG",
      "Hippie+Noir+Headband.PNG",
      "Hippie+Noir.PNG",
      "Hippie+Oat+Headband.PNG",
      "Hippie+Oat.PNG",
      "Hippie+Pink+Headband.PNG",
      "Hippie+Pink.PNG",
      "Hippie+Sienna+Headband.PNG",
      "Long+Cacao.PNG",
      "Long+Gold.PNG",
      "Long+Oat.PNG",
      "Man+Bun+Blue.PNG",
      "Man+Bun+Cacao.PNG",
      "Man+Bun+Gold.PNG",
      "Man+Bun+Noir.PNG",
      "Man+Bun+Oat.PNG",
      "River+Aqua.PNG",
      "River+Blue.PNG",
      "River+Cacao.PNG",
      "River+Gold.PNG",
      "River+Noir.PNG",
      "River+Oat.PNG",
      "River+Pink.PNG",
      "River+Sienna.PNG",
      "Shaggy+Aqua.PNG",
      "Shaggy+Blue.PNG",
      "Shaggy+Cacao.PNG",
      "Shaggy+Gold.PNG",
      "Shaggy+Noir.PNG",
      "Shaggy+Oat.PNG",
      "Shaggy+Pink.PNG",
      "Shaggy+Sienna.PNG",
      "Shaman+Blue.PNG",
      "Shaman+Cacao.PNG",
      "Shaman+Emerald.PNG",
      "Shaman+Gold.PNG",
      "Shaman+Noir.PNG",
      "Shaman+Oat.PNG"
    ],
    "Body": [
      "Alien.PNG",
      "Bandages.PNG",
      "Chill+Cacao.PNG",
      "Chill+Coral.PNG",
      "Chill+Gold.PNG",
      "Chill+Hazelnut.PNG",
      "Chill+Oat.PNG",
      "Chill+Peacan.PNG",
      "Chill+Sandalwood.PNG",
      "Invisible.PNG",
      "Leopard+Orange.PNG",
      "Leopard+Toffee.PNG",
      "Lizard.PNG",
      "Magic+Hands+Cacao.PNG",
      "Magic+Hands+Coral.PNG",
      "Magic+Hands+Gold.PNG",
      "Magic+Hands+Hazelnut.PNG",
      "Magic+Hands+Rosepetal.PNG",
      "Peace+Cacao.PNG",
      "Peace+Coral.PNG",
      "Peace+Gold.PNG",
      "Peace+Hazelnut.PNG",
      "Peace+Rosepetal.PNG",
      "Tiger+Gold.PNG",
      "Tiger+Orange.PNG"
    ],
    "Bottoms": [
      "Flares+Blue.PNG",
      "Flares+Emerald.PNG",
      "Flares+Gold.PNG",
      "Flares+Noir.PNG",
      "Flares+Orange.PNG",
      "Jeans+Blue.PNG",
      "Jeans+Noir.PNG",
      "Joggers+Swirl+Blue.PNG",
      "Joggers+Swirl+Emerald.PNG",
      "Joggers+Swirl+Gold.PNG",
      "Joggers+Swirl+Noir.PNG",
      "Joggers+Swirl+Oat.PNG",
      "Joggers+Swirl+Orange.PNG",
      "Shorts+Blue.PNG",
      "Shorts+Emerald.PNG",
      "Shorts+Gold.PNG",
      "Shorts+Noir.PNG",
      "Shorts+Oat.PNG",
      "Shorts+Orange.PNG",
      "Trainer+Shorts+Blue.PNG",
      "Trainer+Shorts+Emerald.PNG",
      "Trainer+Shorts+Gold.PNG",
      "Trainer+Shorts+Noir.PNG",
      "Trainer+Shorts+Oat.PNG",
      "Trainer+Shorts+Orange.PNG"
    ],
    "Eyes": [
      "Alien.PNG",
      "Aviator.PNG",
      "Beady.PNG",
      "Blue.PNG",
      "Dilated+Blue.PNG",
      "Dilated+Cacao.PNG",
      "Focus.PNG",
      "Glasses+Beady.PNG",
      "Glasses+Focus.PNG",
      "Glasses+Happy.PNG",
      "Glasses+Pink.PNG",
      "Glasses+Surprised.PNG",
      "Glasses+Yellow.PNG",
      "Gold.PNG",
      "Happy.PNG",
      "Heart.PNG",
      "Hypno.PNG",
      "Lennon.PNG",
      "Pink.PNG",
      "Sleepy.PNG",
      "Steampunk+Glasses.PNG",
      "Stoner.PNG",
      "Sunglasses+Gold.PNG",
      "Sunglasses+White.PNG",
      "Sunglasses.PNG",
      "Surprised.PNG",
      "Tripper.PNG",
      "Trippy.PNG",
      "Whateva.PNG"
    ],
    "Hair": [
      "Bushy+Blue.PNG",
      "Bushy+Cacao.PNG",
      "Bushy+Gold.PNG",
      "Bushy+Noir.PNG",
      "Bushy+Oat.PNG",
      "Buzz+Blue.PNG",
      "Buzz+Cacao.PNG",
      "Buzz+Gold.PNG",
      "Buzz+Noir.PNG",
      "Buzz+Sienna.PNG",
      "Crew+Blue.PNG",
      "Crew+Cacao.PNG",
      "Crew+Emerald.PNG",
      "Crew+Noir.PNG",
      "Crew+Oat.PNG",
      "Crew+Sienna.PNG",
      "Fringe+Aqua.PNG",
      "Fringe+Blue.PNG",
      "Fringe+Cacao.PNG",
      "Fringe+Gold.PNG",
      "Fringe+Noir.PNG",
      "Fringe+Oat.PNG",
      "Fringe+Sienna.PNG",
      "Fro+Aqua.PNG",
      "Fro+Cacao.PNG",
      "Fro+Gold.PNG",
      "Fro+Noir.PNG",
      "Fro+Oat.PNG",
      "Fro+Sienna.PNG",
      "Hippie+Aqua+Headband.PNG",
      "Hippie+Aqua.PNG",
      "Hippie+Cacao+Headband.PNG",
      "Hippie+Cacao.PNG",
      "Hippie+Gold+Headband.PNG",
      "Hippie+Gold.PNG",
      "Hippie+Noir+Headband.PNG",
      "Hippie+Noir.PNG",
      "Hippie+Oat+Headband.PNG",
      "Hippie+Oat.PNG",
      "Hippie+Pink+Headband.PNG",
      "Hippie+Pink.PNG",
      "Hippie+Sienna+Headband.PNG",
      "Long+Cacao.PNG",
      "Long+Gold.PNG",
      "Long+Oat.PNG",
      "Man+Bun+Blue.PNG",
      "Man+Bun+Cacao.PNG",
      "Man+Bun+Gold.PNG",
      "Man+Bun+Noir.PNG",
      "Man+Bun+Oat.PNG",
      "River+Aqua.PNG",
      "River+Blue.PNG",
      "River+Cacao.PNG",
      "River+Gold.PNG",
      "River+Noir.PNG",
      "River+Oat.PNG",
      "River+Pink.PNG",
      "River+Sienna.PNG",
      "Shaggy+Aqua.PNG",
      "Shaggy+Blue.PNG",
      "Shaggy+Cacao.PNG",
      "Shaggy+Gold.PNG",
      "Shaggy+Noir.PNG",
      "Shaggy+Oat.PNG",
      "Shaggy+Pink.PNG",
      "Shaggy+Sienna.PNG",
      "Shaman+Blue.PNG",
      "Shaman+Cacao.PNG",
      "Shaman+Emerald.PNG",
      "Shaman+Gold.PNG",
      "Shaman+Noir.PNG",
      "Shaman+Oat.PNG"
    ],
    
    "Mouth": [
      "5+O_Clock+Shadow.PNG",
      "Beard+Aqua.PNG",
      "Beard+Blue.PNG",
      "Beard+Braids+Cacao.PNG",
      "Beard+Braids+Gold.PNG",
      "Beard+Braids+Noir.PNG",
      "Beard+Braids+Oat.PNG",
      "Beard+Braids+Sienna.PNG",
      "Beard+Cacao.PNG",
      "Beard+Gold.PNG",
      "Beard+Noir+Choof.PNG",
      "Beard+Noir.PNG",
      "Beard+Oat.PNG",
      "Beard+Pink.PNG",
      "Beard+Tidy+Aqua.PNG",
      "Beard+Tidy+Blue.PNG",
      "Beard+Tidy+Cacao.PNG",
      "Beard+Tidy+Gold.PNG",
      "Beard+Tidy+Noir.PNG",
      "Beard+Tidy+Oat.PNG",
      "Beard+Tidy+Sienna.PNG",
      "Big+Mouth.PNG",
      "Choof.PNG",
      "Giggle+.PNG",
      "Goatee+Cacao.PNG",
      "Goatee+Oat.PNG",
      "Goatee+Sienna.PNG",
      "Happy+.PNG",
      "Lizard.PNG",
      "Lol.PNG",
      "Moustache.PNG",
      "Salty.PNG",
      "Smile.PNG",
      "Smirk.PNG",
      "Sup.PNG",
      "Tasty.PNG",
      "Tongue+Out.PNG"
    ],
    "Nose": [
      "Nose.PNG"
    ],
    "Pets": [
      "Alice.PNG",
      "Boo.PNG",
      "Cosmic.png",
      "Dynasty.PNG",
      "Eppie.PNG",
      "Flo.png",
      "Grace.png",
      "Hazey.png",
      "Iggy.png",
      "Jinx.png",
      "Kinoko.png",
      "Leya.PNG",
      "Mushie.png",
      "Nirvana.PNG",
      "Otto.PNG",
      "Praise.PNG",
      "Quinn.png",
      "Ruby.png",
      "Sage.PNG",
      "Treasure.png",
      "Unique.PNG",
      "Violet.PNG",
      "Winnie.PNG",
      "Xoxo.PNG",
      "Yogi.PNG",
      "Zen.png"
    ],
    "Shoes": [
      "Air+Black+Black+Socks.PNG",
      "Air+Black.PNG",
      "Air+Blue+White+Socks.PNG",
      "Air+Blue.PNG",
      "Air+Emerald.PNG",
      "Air+Gold+White+Socks.PNG",
      "Air+Hippie+Black.PNG",
      "Air+Hippie+White+Socks.PNG",
      "Air+Hippie.PNG",
      "Air+Orange+White+Socks.PNG",
      "Air+Orange.PNG",
      "Crocs+Blue.PNG",
      "Crocs+Emerald.PNG",
      "Crocs+Orange.PNG",
      "Crocs+Pink.PNG",
      "Crocs+White.PNG",
      "Furry+Boots+Blue.PNG",
      "Furry+Boots+Gold.PNG",
      "Furry+Boots+Oat.PNG",
      "Furry+Boots+Orange.PNG",
      "Furry+Boots+Pink.PNG",
      "Furry+Boots+Rainbow.PNG",
      "Male+Black+Socks.PNG",
      "Male+Bunny+Slippers+Black+Socks.PNG",
      "Male+Bunny+Slippers+White+Socks.PNG",
      "Male+Bunny+Slippers.PNG",
      "Male+Converse+Black.PNG",
      "Male+Converse+Blue+Low.PNG",
      "Male+Converse+Blue.PNG",
      "Male+Converse+Gold.PNG",
      "Male+Converse+Low+Gold.PNG",
      "Male+Converse+Low+Noir+Socks.PNG",
      "Male+Converse+Low+Orange.PNG",
      "Male+Converse+Low+White+Socks.PNG",
      "Male+Converse+Low+White.PNG",
      "Male+Converse+White.PNG",
      "Male+Gold+Stripe+Socks.PNG",
      "Male+MJ+Socks+Noir.PNG",
      "Male+MJ+Socks+White.PNG",
      "Male+Sandals.PNG",
      "Male+Sneakers+Gold+Stripe+Socks.PNG",
      "Male+Sneakers+MJ+Socks.PNG"
    ],
    "Tattoo": [
      "Male+Tattoo.PNG"
    ],
    "Tops": [
      "Hoodie+Mushroom+Blue.PNG",
      "Hoodie+Mushroom+Emerald.PNG",
      "Hoodie+Mushroom+Gold.PNG",
      "Hoodie+Mushroom+Noir.PNG",
      "Hoodie+Mushroom+Orange.PNG",
      "Hoodie+Swirl+Blue.PNG",
      "Hoodie+Swirl+Emerald.PNG",
      "Hoodie+Swirl+Gold.PNG",
      "Hoodie+Swirl+Noir.PNG",
      "Hoodie+Tree+Love+Blue.PNG",
      "Hoodie+Tree+Love+Emerald.PNG",
      "Hoodie+Tree+Love+Gold.PNG",
      "Hoodie+Tree+Love+Noir.PNG",
      "Hoodie+Tree+Love+Oat.PNG",
      "Hoodie+Tree+Love+Pink.PNG",
      "Hoodie+Tree+of+Life+Emerald.PNG",
      "Hoodie+Tree+of+Life+Gold.PNG",
      "Hoodie+Tree+of+Life+Oat.PNG",
      "Hoodie+Vibing+Blue.PNG",
      "Hoodie+Vibing+Emerald.PNG",
      "Hoodie+Vibing+Noir.PNG",
      "Hoodie+Vibing+Orange.PNG",
      "Jacket+Blue.PNG",
      "Jacket+Gold.PNG",
      "Polo+Blue.PNG",
      "Polo+Emerald.PNG",
      "Polo+Gold.PNG",
      "Polo+Noir.PNG",
      "Polo+Oat.PNG",
      "Polo+Orange.PNG",
      "Poncho+Blue+Swirl.PNG",
      "Poncho+Emerald.PNG",
      "Poncho+Orange+Swirl.PNG",
      "Shirt+Blue.PNG",
      "Shirt+Emerald.PNG",
      "Shirt+Gold.PNG",
      "Shirt+Noir.PNG",
      "Swirl+Top+Blue.PNG",
      "Swirl+Top+Emerald.PNG",
      "Swirl+Top+Gold.PNG",
      "Swirl+Top+Orange.PNG",
      "Tee+Eye+Blue.PNG",
      "Tee+Eye+Noir.PNG",
      "Tee+Eye+Oat.PNG",
      "Tee+Mushroom+Blue.PNG",
      "Tee+Mushroom+Emerald.PNG",
      "Tee+Mushroom+Noir.PNG",
      "Tee+Mushroom+Oat.PNG",
      "Tee+Peace+Blue.PNG",
      "Tee+Peace+Emerald.PNG",
      "Tee+Peace+Noir.PNG",
      "Tee+Peace+Oat.PNG",
      "Tee+Smilie+Blue.PNG",
      "Tee+Smilie+Gold.PNG",
      "Tee+Smilie+Oat.PNG",
      "Tee+Smilie+Orange.PNG",
      "Tee+Smilie+Tie+Dye.PNG",
      "Tee+Thrive+Emerald.PNG",
      "Tee+Thrive+Noir.PNG",
      "Tee+Thrive+Oat.PNG",
      "Tee+Tie+Dye.PNG",
      "Tee+Tree+Love+Blue.PNG",
      "Tee+Tree+Love+Emerald.PNG",
      "Tee+Tree+Love+Gold.PNG",
      "Tee+Tree+Love+Noir.PNG",
      "Tee+Tree+of+Life+Blue.PNG",
      "Tee+Tree+of+Life+Emerald.PNG",
      "Tee+Tree+of+Life+Gold.PNG",
      "Tee+Tree+of+Life+Oat.PNG",
      "Tee+Vibing+Blue.PNG",
      "Tee+Vibing+Emerald.PNG",
      "Tee+Vibing+Noir.PNG",
      "Tee+Vibing+Orange.PNG",
      "Tee+Weed+Blue.PNG",
      "Tee+Weed+Emerald.PNG",
      "Tee+Weed+Gold.PNG",
      "Tee+Weed+Oat.PNG",
      "Vest+Blue.PNG",
      "Vest+Gold.PNG",
      "Vest+Tee+Blue.PNG",
      "Vest+Tee+Noir.PNG",
      "Vest+Tee+Oat+Gold.PNG",
      "Vest+Tee+Oat+Pink.PNG",
      "Vest+Tee+Orange+Pink.PNG",
      "Vest+Tie+Dye+Gold.PNG"
    ]
  },
  "Female": {
    "Aura": [
      "Awaken.PNG"
    ],
    "Bling": [
      "Alien+Bling+Single.PNG"
    ],
    "Body": [
      "Alien.PNG"
    ],
    "Bottoms": [
      "Flares+Blue.PNG"
    ],
    "Eyes": [
      "Alien.PNG"
    ],
    "Hair": [
      "Bushy+Blue.PNG"
    ],
    "Hats": [
      "Beanie+Aqua.PNG"
    ],
    "Mouth": [
      "5+O_Clock+Shadow.PNG"
    ],
    "Nose": [
      "Nose.PNG"
    ],
    "Pets": [
      "Alice.PNG"
    ],
    "Shoes": [
      "Air+Black+Black+Socks.PNG"
    ],
    "Tattoo": [
      "Male+Tattoo.PNG"
    ],
    "Tops": [
      "Hoodie+Mushroom+Blue.PNG"
    ]
  }
}
export default assetStickers